import PinSDK from './PinSDK';

export default PinSDK;
